import { render } from "./FileLoader.vue?vue&type=template&id=35adc950&scoped=true"
import script from "./FileLoader.vue?vue&type=script&lang=js"
export * from "./FileLoader.vue?vue&type=script&lang=js"

import "./FileLoader.vue?vue&type=style&index=0&id=35adc950&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35adc950"]])

export default __exports__